import { environment } from './../../../../environments/environment';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { UserService } from 'src/app/services/user/user.service';
import { PaymentTerminalService } from './../../../services/payment-terminal/payment-terminal.service';
import { PopoverComponent } from './../../../components/popover/popover.component';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { PopoverController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { Component, OnInit, Input } from '@angular/core';
import {
  IPaymentTerminal,
  fieldsPayment,
  commerce,
  imgbanner,
} from './IPayment-terminal.model';
import { ModalController } from '@ionic/angular';

export const KEY_LAST_CATEGORY_SELECT = 'KEY_LAST_CATEGORY_SELECT';

@Component({
  selector: 'app-payment-terminal',
  templateUrl: './payment-terminal.page.html',
  styleUrls: ['./payment-terminal.page.scss'],
})
export class PaymentTerminalPage implements OnInit {
  PaymentData: IPaymentTerminal;
  imageProvider = '';
  points: any;
  fields: Array<fieldsPayment> = [];
  commerce: Array<commerce> = [];
  imgbanner: Array<imgbanner> = [];
  PaymentTerminalForm: FormGroup;
  loadingForm = false;
  LOADER_ID = 'paymentTerminal-form';
  IsOpen = false;
  categories = [];
  userinfo: { name: any; docId: any; lastname: any; docType: any } = {
    name: '',
    docId: '',
    lastname: '',
    docType: '',
  };

  loading = true;
  public_id_cloudinary = environment.public_id_cloudinary;
  constructor(
    public languageService: LanguagesService,
    private remoteConfig: RemoteConfigService,
    private formBuilder: FormBuilder,
    private storageServices: StorageService,
    private loaderService: LoaderService,
    private alertService: AlertService,
    private router: Router,
    private popoverController: PopoverController,
    private paymentTerminalService: PaymentTerminalService,
    private userService: UserService,
    private utilsService: UtilsService,
    private modalController: ModalController
  ) {
    this.PaymentTerminalForm = this.formBuilder.group({});
  }

  async ngOnInit() {
    this.remoteConfig
      .getSettingPaymentTerminalConfig()
      .subscribe((data: IPaymentTerminal) => {
        this.PaymentData = data;
        console.log(data);
        this.getPoints();
      });
    this.generateForm();
    this.getUserInfo();

    /* const categories : any =  await this.paymentTerminalService.getCategories();
    this.categories = categories.data */

    this.paymentTerminalService
      .getCategories()
      .then((categories: any) => {
        this.categories = categories.data;
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        console.log(error);
      });
  }

  ionViewDidEnter() {
    this.getPoints();
    this.PaymentTerminalForm.reset();
  }

  getUserInfo() {
    this.userService.getUserInfo().subscribe(async (basicUserInfo: any) => {
      this.userinfo.name = basicUserInfo.name;
      this.userinfo.docId = basicUserInfo.gnxCredential1;
      this.userinfo.lastname = basicUserInfo.lastnames;
      this.userinfo.docType = basicUserInfo.docType;
    });
  }

  async generateForm() {
    const fieldsData = await this.remoteConfig
      .getSettingPaymentTerminalConfig()
      .toPromise();
    this.fields = fieldsData.fields;
    let validations = [];
    this.fields.map(async (field) => {
      validations = [];
      field.validations?.includes('required')
        ? validations.push(Validators.required)
        : '';
      field.validations?.includes('min')
        ? validations.push(
            Validators.minLength(field.validations.split(':')[0])
          )
        : '';
      field.validations?.includes('max')
        ? validations.push(
            Validators.maxLength(field.validations.split(':')[0])
          )
        : '';

      if (field.type == 'number' && field.isPhone) {
        validations.push(Validators.pattern(/^[0-9]*$/));
      }

      await this.PaymentTerminalForm.addControl(
        field.name,
        field.subfields
          ? this.formBuilder.array([], validations)
          : this.formBuilder.control('', validations)
      );
    });

    this.f['price'].valueChanges.subscribe(() => {});
  }

  getPoints() {
    console.log('getPoints', this.PaymentData?.viewPoint);

    if (this.PaymentData?.viewPoint) {
      this.utilsService.getUserPoints().then((result: any) => {
        console.log(result);

        this.points = result;
      });
    }
  }

  async sendForm() {
    console.log({ ...this.PaymentTerminalForm });
    this.loadingForm = true;
    this.loaderService.presentLoading(this.LOADER_ID);

    if (this.PaymentTerminalForm.valid) {
      this.loadingForm = false;
      await this.loaderService.cancelLoader(this.LOADER_ID);

      const price = (this.PaymentTerminalForm.value.price as string)
        .replace(/\./g, '')
        .replace(',', '.')
        .replace(/\./g, '');
      //const price = (this.PaymentTerminalForm.value.price)
      console.log(price);

      const canExchange: any = await this.paymentTerminalService.canExchange(
        parseInt(price)
      );
      console.log('canExchange == ', canExchange);

      if (canExchange) {
        const type = canExchange.canExchange ? 1 : 2;
        this.PaymentTerminalForm.reset();
        this.openModal(type);
      }
    } else {
      this.loaderService.cancelLoader(this.LOADER_ID);
      this.alertService.presentAlert('Debes diligenciar los campos requeridos');
    }
  }

  async openbrands(category) {
    await this.storageServices.set(KEY_LAST_CATEGORY_SELECT, category);
    this.router.navigate([`app/brands`, category.id]);
  }

  async openModal(msg) {
    console.log('open msg ', msg);
    if (!this.IsOpen) {
      const modal = await this.modalController.create({
        component: ModalAlertsComponentPayment,
        id: 'redemption-modal',
        componentProps: {
          data: msg,
          onClose: async (data) => {
            await modal.dismiss({ dismissed: true });
          },
        },
        cssClass: 'my-custom-height-modal-redemption',
        backdropDismiss: false,
        swipeToClose: false,
      });

      modal.onDidDismiss().then(() => {
        this.IsOpen = false;
        this.closeAllModalsRedemption();
      });
      return await modal.present().then(() => {
        this.IsOpen = true;
        const el = document.getElementsByTagName('ion-modal');
        for (let i = 0; i < el.length; i++) {
          const element = el[i];
          if (element.id == 'redemption-modal') {
            element.style.setProperty('--height', '40vh');
          }
        }
      });
    }
  }

  getInputPrice() {
    let x;
    const intervalId = setInterval(() => {
      const idPrice = document.getElementById('price');
    }, 1000);
  }

  closeAllModalsRedemption() {
    const alerts = document.getElementsByTagName('ion-modal');
    for (let i = 0; i < alerts.length; i++) {
      const element = alerts[i];
      if (element.id == 'redemption-modal') {
        element.remove();
      }
      element.dismiss();
    }
  }

  get getTextsIUPagePaymenterminalServices() {
    return this.languageService.textsIU.page_payment_terminal;
  }

  get f() {
    return this.PaymentTerminalForm.controls;
  }

  async presentPopover(ev: any, field) {
    console.log(field.valueHelp);

    const popover = await this.popoverController.create({
      component: PopoverComponent,
      event: ev,
      translucent: true,
      componentProps: {
        message: field.valueHelp,
      },
    });
    return await popover.present();
  }

  keyPressNumber($event) {
    return this.utilsService.keyPressNumber($event);
  }
}

@Component({
  selector: 'app-modal-alerts-paymen-terminal',
  templateUrl: './modal-alerts-paymen-terminal.html',
  styleUrls: ['./modal-alerts-paymen-terminal.scss'],
})
export class ModalAlertsComponentPayment implements OnInit {
  @Input() data = 0;
  empyFields = false;
  msjRedemption = '';
  iconRedemption = '';
  iconRedemption1 = '';
  iconRedemption2 = '';
  iconRedemption3 = '';
  iconRedemption4 = '';
  msjRedemption1 = '';
  msjRedemption2 = '';
  msjRedemption3 = '';
  msjRedemption4 = '';

  constructor(
    private modalController: ModalController,

    private languageService: LanguagesService
  ) {}

  async ngOnInit() {
    let close = true;

    if (this.data === 1) {
      this.msjRedemption = `
        ¡Genial! Tienes saldo suficiente para realizar el pago en nuestros aliados`;
      this.iconRedemption = '../../../assets/icons/home/happy-outline.svg';
    }

    if (this.data === 2) {
      this.msjRedemption = `
        Tus coins no te alcanzan, a partir de 1 punto puedes completar el pago con otros medios de pago o seguir acumulando`;
      this.iconRedemption =
        '../../../assets/icons/home/alert-circle-outline.svg';
    }

    if (this.data === 3) {
      this.msjRedemption = ` Sigue estos pasos Para pagar con tus coins En nuestros aliados.`;
      this.iconRedemption1 =
        '../../../assets/icons/home/password_black_24dp.svg';
      this.msjRedemption1 = ` Genera tu clave`;
      this.iconRedemption2 =
        '../../../assets/icons/home/storefront-outline.svg';
      this.msjRedemption2 = ` Usa tus coins para pagar en nuestros aliados`;
      this.iconRedemption3 =
        '../../../assets/icons/home/calculator-outline.svg';
      this.msjRedemption3 = ` Ingresa tu clave en el datáfono aliado`;
      this.iconRedemption4 =
        '../../../assets/icons/home/checkmark-done-circle-outline.svg';
      this.msjRedemption4 = ` Disfruta tu compra`;
    }

    // if (this.data === 4) {
    //   this.msjRedemption = `Ocurrio un error ...`;
    //   this.iconRedemption = "../../../assets/icons/home/alert-circle-outline.svg";
    // }

    // if(typeof this.data === 'object'){
    //   console.log(this.data, typeof this.data);
    //   this.iconRedemption = "../../../assets/icons/home/alert-circle-outline.svg";
    //   this.msjRedemption = 'Por favor, ingresa la siguiente información en el perfil y genera nuevamente tu clave de acceso'
    //   this.empyFields = true;

    //   Object.keys(this.data).forEach(key => {

    //     if (this.data[key] == 'name') {
    //       this.data[key] = 'Nombres'
    //     } else if (this.data[key] == 'lastname'){
    //       this.data[key] = 'Apellidos'
    //     } else if (this.data[key] == 'phone'){
    //       this.data[key] = 'Télefono'
    //     } else if (this.data[key] == 'docNumber'){
    //       this.data[key] = 'Numero de Documento'
    //     } else if (this.data[key] == 'email'){
    //       this.data[key] = 'Correo electrónico'
    //     }

    //     console.log(this.data[key]);
    //   });
    // }

    if (!close) return;
  }

  dismiss() {
    this.modalController.dismiss().then(() => {});
  }
  get getTextIUCurrency() {
    return this.languageService.textsIU.currency_data;
  }
}
